import { createTheme, ThemeProvider } from "@mui/material/styles";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import MainApp from "./MainApp";
import { useEffect, useState } from "react";

function App() {
  const [basePath, setBasePath] = useState('');
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkConfig = () => {
      if (window.appConfig) {
        const configBasename = window.appConfig.basename || '';
        console.log('Using basename from config:', configBasename);
        setBasePath(configBasename);
        setIsReady(true);
        return true;
      }
      return false;
    };

    if (!checkConfig()) {
      const interval = setInterval(() => {
        if (checkConfig()) {
          clearInterval(interval);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
        console.warn('Config not available after timeout, proceeding with default settings');
        setBasePath('');
        setIsReady(true);
      }, 2000);

      return () => clearInterval(interval);
    }
  }, []);

  if (!isReady) {
    return <div>Inizializzazione...</div>;
  }

  return (
    <Provider store={store}>
        <HashRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/doc" replace />} />
            <Route path="/*" element={<MainApp basePath={basePath} />} />
          </Routes>
        </HashRouter>
    </Provider>
  );
}

export default App;